<template>
  <dl class="input-block">
    <dt>リセットタイム</dt>
    <dd>
      <SelectBox class="select--time" v-model.number="_value" :disabled="isDisabled">
        <template #icon><ClockIcon /></template>
        <option value="0">0分</option>
        <option value="15">15分</option>
        <option value="30">30分</option>
      </SelectBox>
    </dd>
  </dl>
</template>

<script>
import { mapState } from 'vuex'
import SelectBox from '@/components/atoms/SelectBox'
import { isBlock } from '@/resources/reservation/typeMap'
import { syncFromGnavi } from '@/resources/reservation/syncTypeMap'
import ClockIcon from '@/components/icons/clock'

export default {
  name: 'ResetTimeInput',
  components: {
    SelectBox,
    ClockIcon,
  },
  computed: {
    ...mapState({
      resetTime: state => state.reserves.edit.reservation.resetTime,
      syncType: state => state.reserves.edit.reservation.syncType,
      type: state => state.reserves.edit.reservation.type,
      defaultResetTime: state => state.stores.current.store.time.reset || 0,
    }),
    _value: {
      get() {
        return this.resetTime !== null ? this.resetTime : this.defaultResetTime
      },
      set(resetTime) {
        this.$store.commit('reserves/edit/update', { resetTime })
      },
    },
    isDisabled() {
      return !!syncFromGnavi[this.syncType] || isBlock(this.type)
    },
  },
}
</script>

<style lang="postcss" scoped>
.select--time {
  margin-top: 8px;
  width: 224px;
}
</style>
